<template>
  <b-card class="eff-item mb-3 py-3 px-2" align="center" no-body>
    <b-card-text class="mb-0 eff-item-title"
      >{{ title }} Efficiency</b-card-text
    >
    <b-card-text class="mb-0 eff-item-value">{{
      utils.bigToCommon(value, 18, 2)
    }}</b-card-text>
  </b-card>
</template>
<script>
export default {
  name: "PEffInfo",
  props: ["title", "value"],
};
</script>

<style lang="scss" scoped>
.eff-item {
  min-height: 76px;
  width: calc(25% - 16px);
  background-color: transparent;
  border: 1px solid #474a5b;
  border-radius: 0;
  margin-right: 16px;

  @media (max-width: 991px) {
    width: calc(33.33% - 16px);
  }
  @media (max-width: 767px) {
    width: calc(50% - 16px);
  }
  .eff-item-title {
    color: #8f8fa9;
    font-weight: bold;
  }
  .eff-item-value {
    color: #fff;
    font-weight: bold;
    font-size: 20px;
  }
}
</style>
